/**
 * GuideContent — middle pane. Renders the active section. Keeps a
 * reasonable max-width for readability (~70ch). Scroll into the
 * #anchor on first render so deep-links land correctly.
 */
import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { GuideSection } from './sections/types';

interface Props {
  section: GuideSection;
  anchor?: string;
}

const GuideContent: React.FC<Props> = ({ section, anchor }) => {
  useEffect(() => {
    // Allow the section content to mount, then jump.
    if (!anchor) {
      // Reset scroll for fresh section
      window.requestAnimationFrame(() => {
        const el = document.getElementById('app-guide-content-top');
        if (el) el.scrollIntoView({ behavior: 'auto', block: 'start' });
      });
      return;
    }
    const t = setTimeout(() => {
      const el = document.getElementById(`anchor-${anchor}`);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 50);
    return () => clearTimeout(t);
  }, [anchor, section.id]);

  return (
    <Box
      id="app-guide-content-top"
      className="app-guide-content"
      sx={{
        flex: 1,
        minWidth: 0,
        px: { xs: 2, md: 4 },
        py: 3,
        maxWidth: '78ch',
      }}
    >
      {section.render()}
    </Box>
  );
};

export default GuideContent;
